import TextAreaInput from './TextAreaInput';

export * from './TextAreaInput';

export default TextAreaInput;
